import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';

import { notesShape, journeyShape, bookingShape, historyShape } from 'constants/propTypes';

import styled from 'styled-components';
import Button from 'components/ui/Button';
import { StyledContents, StyledTab } from './ModuleTabs.styles';
import { isLoyaltyBooking } from '../../../utils/booking';

const ErrorButton = styled(Button)`
  display: block;
  margin: auto;
`;

const ModuleTabs = ({
  notes,
  reference,
  outbound,
  inbound,
  intl: { formatMessage },
  location: { pathname, search },
  assistances = [],
  extras = [],
  booking,
  history
}) => {
  const activeTabId = pathname.split(`${reference}/`)[1];
  const numberOfNotes = notes.length;
  const numberOfJourneys = inbound.length + outbound.length;
  const numberOfAssistances = assistances.length;
  const numberOfExtras = extras.length;
  const membershipNumber = new URLSearchParams(search).get('membershipNumber');
  const membershipNumberUrl = membershipNumber ? `?membershipNumber=${membershipNumber}` : '';
  const shouldShowLogInWarning = isLoyaltyBooking(booking) && !membershipNumber;

  return (
    <>
      <StyledContents id="manage-your-booking-tabs">
        {['journeys', 'passengers', 'assistance', 'extras', 'payments', 'notes'].map((id) => (
          <StyledTab
            key={id}
            to={`/manage/bookings/${reference}/${id}${membershipNumberUrl}`}
            selected={activeTabId === id}
            data-cy={`${id}-tab`}
          >
            {formatMessage({
              id: `pnrTabs.${id}`
            })
              .replace('__numberOfNotes__', `(${numberOfNotes})`)
              .replace('__numberOfAssistances__', `(${numberOfAssistances})`)
              .replace('__numberOfExtras__', `(${numberOfExtras})`)
              .replace('__numberOfJourneys__', `(${numberOfJourneys})`)}
          </StyledTab>
        ))}
      </StyledContents>
      {shouldShowLogInWarning && (
        <ErrorButton
          onClick={() =>
            history.push(`/clubeurostar/manage`, {
              prevPath: history.location.pathname,
              prevSearch: history.location.search,
              prevHash: history.location.hash
            })
          }
          id="error-page-cta"
        >
          <FormattedMessage id="afterSales.notLoggedInClubEurostar" />
        </ErrorButton>
      )}
    </>
  );
};

ModuleTabs.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
    search: PropTypes.string
  }),
  notes: notesShape,
  reference: PropTypes.string.isRequired,
  outbound: journeyShape,
  inbound: journeyShape,
  assistances: PropTypes.arrayOf(PropTypes.object),
  extras: PropTypes.arrayOf(PropTypes.object),
  history: historyShape,
  booking: bookingShape
};
export default injectIntl(ModuleTabs);
